import { reducer as login } from './login'
import { reducer as assignRole } from './assignRole'
import { reducer as deleteAccount } from './deleteAccount'
import { reducer as getAccounts } from './getAccounts'
import { reducer as getRoles } from './getRoles'
import { reducer as setEmail } from './setEmail'
import { reducer as setPassword } from './setPassword'
import { reducer as unassignRole } from './unassignRole'
import { reducer as userInfo } from './userInfo'
import { reducer as selectedAccount } from './selectedAccount'
import { reducer as createAccount } from './createAccount'
import { reducer as createAccountModal } from './createAccountModal'
import { reducer as userLocale } from './userLocale'
import { reducer as syncAccounts } from './syncAccounts'
import { reducer as updateAccount } from './updateAccount'

export default {
  login,
  assignRole,
  deleteAccount,
  getAccounts,
  getRoles,
  setEmail,
  setPassword,
  unassignRole,
  userInfo,
  selectedAccount,
  createAccount,
  createAccountModal,
  userLocale,
  syncAccounts,
  updateAccount
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js